import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { ReleaseNotes } from './pages/ReleaseNotes';
import { ScrollToTop } from './components/ScrollToTop';
import './styles/brand-variables.css';
import './styles/landing.css';
import './styles/animations.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/release-notes" element={<ReleaseNotes />} />
      </Routes>
    </Router>
  );
}

export default App;
